import { handleStreamResolutionFailure } from './streamResolutionSkip';

export async function runQueueStreamResolutionFailureFor(
  qc: {
    _playIntent: 'user' | 'queue-advance';
    _claimFailureRecovery: (owner: string) => boolean;
    _releaseFailureRecovery: () => void;
    _restorePlaybackSnapshot: (snap: unknown) => void;
    _playTrack: (track: unknown, options: { intent: 'queue-advance' }) => Promise<void>;
    _clearPlayTrackInflight: () => void;
  },
  priorPlayback: unknown,
): Promise<void> {
  await handleStreamResolutionFailure({
    playIntent: qc._playIntent,
    priorPlayback: priorPlayback as Parameters<typeof handleStreamResolutionFailure>[0]['priorPlayback'],
    claimFailureRecovery: (owner) => qc._claimFailureRecovery(owner),
    releaseFailureRecovery: () => qc._releaseFailureRecovery(),
    restorePlaybackSnapshot: (snap) => qc._restorePlaybackSnapshot(snap),
    playNextTrack: (track) => qc._playTrack(track, { intent: 'queue-advance' }),
    clearPlayTrackInflight: () => qc._clearPlayTrackInflight(),
  });
}
